module.exports = __webpack_public_path__ + "img/camera.ef744a9c.png";